<template>
  <div class="center-warp">
    <div class="inner">
<!--      业务员显示-->
      <div class="bill-count" v-if="queryParams.doctor_id && member.member_type == 2">上月已收到耗材{{ billCount.count }}件（免费{{ billCount.free_count }}件，付费{{ billCount.paid_count }}件）</div>
      <div class="top-search">
        <Input :placeholder="'搜索耗材名称、耗材编号、订单编号、医生名称或病例名称'" v-model="queryParams.keyWords" @enter="handleQuery"/>
        <div class="iconfont icon-sousuo" @click="handleQuery"></div>
      </div>
      <!--      订单列表-->
      <div class="billList">
        <!--          状态-->
        <div class="top-nav">
          <div :class="queryParams.order_status == -1 || queryParams.order_status == undefined ? 'on' : ''" @click="navChange(-1)">全部</div>
          <div :class="queryParams.order_status == 0 ? 'on' : ''" @click="navChange(0)">待确认</div>
          <div :class="queryParams.order_status == 4 ? 'on' : ''" @click="navChange(4)">待修改</div>
          <div :class="queryParams.order_status == 1 ? 'on' : ''" @click="navChange(1)">待发货</div>
          <div :class="queryParams.order_status == 2 ? 'on' : ''" @click="navChange(2)">已发货</div>
          <div :class="typeof queryParams.order_status == 'object' && (queryParams.order_status.indexOf(3) !== -1 || queryParams.order_status.indexOf(7) !== -1)? 'on' : ''" @click="navChange(3, 7)">已结束</div>
        </div>
        <!--        订单内容显示-->
        <div v-loading="loading" class="bill-center-height">
          <div class="item hover-shadow" v-for="(item,index) in list" :key="index" @click="handleDetail(item)">
            <div class="bill_content">
              <!--                    领取时间和状态-->
              <div class="time_type">
                <span>领取时间：{{item.doctor_claim_time}}</span>
                <span class="type type1" v-if="item.order_status===0">待确认</span>
                <span class="type type2" v-else-if="item.order_status===2">已发货</span>
                <span class="type type3" v-else-if="item.order_status===1">待发货</span>
                <span class="type type4" v-else-if="item.order_status===3">已完成</span>
                <span class="type type4" v-else-if="item.order_status===4">待修改</span>
                <span class="type type4" v-else-if="item.order_status===7">已取消</span>
              </div>
              <div class="itemInfo">
                <img class="itemImg" :src="item.product_pic">
                <div>
                  <div class="title">{{item.product_name}}</div>
                  <div class="desc">分类：{{item.product_category_name}}{{ item.product_is_dz == 1 ? ';定制耗材' : ';标准耗材' }}</div>
                  <div class="number">×{{item.product_quantity}}
                    <template v-if="item.order_status===3 && (item.free_count > 0 || item.paid_count > 0)">
                      (<span v-if="item.free_count > 0 ">免费{{item.free_count}}件</span>
                      <span v-if="item.paid_count > 0 && item.free_count > 0">，</span>
                      <span v-if="item.paid_count > 0 ">付费{{item.paid_count}}件</span>)
                    </template>
                  </div>
                  <div class="who">{{item.doctor_name}}医生<span v-if="item.patient"> | {{item.patient.name}}（{{item.patient.no}}）</span></div>
                </div>
              </div>
            </div>
          </div>
          <Empty v-if="!list.length" :info="'暂无订单'" :img-width="'200px'" />
        </div>
        <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="'page' + queryParams.page" />
      </div>

    </div>
  </div>
</template>

<script>
import {search, doctorOrderList, salemanGetOrderList} from "@/http/order";
import Pagination from "@/components/Pagination";

export default {
  name: "index",
  components: { Pagination },
  data() {
    return {
      input: "",
      navIndex: 1,
      list: [],
      total: 0,
      last_page: 0,
      queryParams: {
        page: 1,
        pageSize: 6,
        order_status: undefined,
        keyWords: undefined,
        doctor_id: undefined,
      },
      loading: false,
      member:JSON.parse(localStorage.getItem('member')),
      billCount:{
        count:0,
        free_count:0,
        paid_count:0
      }
    };
  },
  mounted() {
    if (this.$route.query.doctor_id) {
      this.queryParams.doctor_id = this.$route.query.doctor_id;
    }
    if (this.$route.query.type) {
      this.navChange(this.$route.query.type)
    }
    if (this.$route.query.name)
      this.$store.commit("breadChange", {
        name: this.$route.query.name + "医生的订单",
        isBack: true,
      });
    this.getList();
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    navChange(...i) {
      this.queryParams.order_status = i.length > 1 ? i : i[0];
      this.handleQuery();
    },
    getList() {
      var self = this;
      this.loading = true;
      if (this.queryParams.doctor_id) {
        //业务员显示统计数据
        if(this.member.member_type == 2){
          salemanGetOrderList(this.queryParams).then((res) => {
            self.list = res.data.data.data;
            self.total = res.data.data.total;
            self.last_page = res.data.data.last_page;
            self.loading = false;
            self.billCount.count = res.data.count
            self.billCount.free_count = res.data.free_count
            self.billCount.paid_count = res.data.paid_count
          });
        }else{
          doctorOrderList(this.queryParams).then((res) => {
            self.list = res.data.data;
            self.total = res.data.total;
            self.last_page = res.data.last_page;
            self.loading = false;
          });
        }
      } else {
        search(this.queryParams).then((res) => {
          self.list = res.data.data;
          self.total = res.data.total;
          self.last_page = res.data.last_page;
          self.loading = false;
          // loading.close()
        });
      }
    },
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleDetail(row) {
      window.open("/bill_center/detail?id=" + row.id ,'_blank')
    },
  },
};
</script>


<style scoped src="../../assets/css/bill_center.css">
</style>
